/**
 * Clamps a value between min and max
 */
export function clamp(value: number, min: number, max: number): number {
  if (value > max) return max;
  if (value < min) return min;
  return value;
}

/**
 * Linear interpolation between start and end values
 * @param start - Starting value
 * @param end - Ending value
 * @param t - Interpolation factor (0-1)
 */
export function lerp(start: number, end: number, t: number): number {
  return start + (end - start) * clamp(t, 0, 1);
}
